module.exports = __webpack_public_path__ + "static/media/logo-mieres.487f8f70.jpg";